import React, { Component } from 'react';
import _ from 'lodash';
import ReactDataGrid from 'react-data-grid';
import { SkyLightStateless } from 'react-skylight';
import { Field } from 'redux-form';
import { Translate } from 'react-redux-i18n';
import { Toolbar, Data } from 'react-data-grid-addons';
import { Grid, Row, Col, Panel, ButtonToolbar, Button, Breadcrumb } from 'react-bootstrap';
import { numberWithCommas } from '../Common/numberWithCommas';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import { UI_HEIGHT } from '../Common/constants';
import Spinner from '../../components/Widgets/spinner';
import { DatePicker, DisabledDatePicker } from '../Common/datePicker';
import { toFromDates } from '../Common/cleanDates';
import ConfirmActionModal from '../Common/confirmActionModal';
import PercentFormatter from '../Common/percentFormatter';
import checkPermission from '../Common/permissions';
import { Selection } from '../Common/selection';
import { POSGraphModal } from '../Common/posGraphModal';
import { ROOT_URL, ROOT_API_URL, companyCodeTitle, isOLG, isARC, isGFD, isSUN, isCPG } from '../../actions/root_url';

const isEcity = ROOT_API_URL === "https://ctstage-scm.truckxi.com/api/"|| ROOT_API_URL === 'https://ct-scm.truckxi.com/api/';
const isMMD = ROOT_API_URL === "https://mmdavis-scm.truckxi.com/api/"|| ROOT_API_URL === 'https://mmdavis-scm.truckxi.com/api/';
const getBsStyle = (input, value) => (input === value ? 'success' : 'primary');

let renderRadios = (props) => {
  const renderStartDatePicker = (days) => {
    if (days === '-1') {
      return (
        <Button bsStyle="primary">
          <Field name="FromDate" placeholder="Start" component={DatePicker} />
        </Button>
      );
    }
    return (
      <Button bsStyle="primary">
        <Field name="FromDate" placeholder="Start" component={DisabledDatePicker} />
      </Button>
    );
  };
  const renderEndDatePicker = (days) => {
    if (days === '-1') {
      return (
        <Button bsStyle="primary">
          <Field name="ToDate" placeholder="End" component={DatePicker} />
        </Button>
      );
    }
    return (
      <Button bsStyle="primary">
        <Field name="ToDate" placeholder="End" component={DisabledDatePicker}/>
      </Button>
    );
  };
  return (
    <ButtonToolbar className="radio-filter-buttons">
      <Button bsStyle={getBsStyle(props.input.value, '1')}>
        <div className="radio">
          <label htmlFor="today-radio-filter">
            <input {...props.input} id="today-radio-filter" type="radio" name="dateFilterRadios" value="1" onClick={()=>{props.fetchPosOrdersByDetails('1');}} checked={props.input.value === '1'} />
            <Translate value="today" />
          </label>
        </div>
      </Button>
      <Button bsStyle={getBsStyle(props.input.value, '7')}>
        <div className="radio">
          <label htmlFor="sevenDay-radio-filter">
            <input {...props.input} id="sevenDay-radio-filter" type="radio" name="dateFilterRadios" value="7" onClick={()=>{props.fetchPosOrdersByDetails('7');}} checked={props.input.value === '7'} />
            <span>7 <Translate value="days" /></span>
          </label>
        </div>
      </Button>
      <Button bsStyle={getBsStyle(props.input.value, '30')}>
        <div className="radio">
          <label htmlFor="thirtyDay-radio-filter">
            <input {...props.input} id="thirtyDay-radio-filter" type="radio" name="dateFilterRadios" value="30" onClick={()=>{props.fetchPosOrdersByDetails('30');}} checked={props.input.value === '30'} />
            30 <Translate value="days" />
          </label>
        </div>
      </Button>
      <Button bsStyle={getBsStyle(props.input.value, '90')}>
        <div className="radio">
          <label htmlFor="ninetyDay-radio-filter">
            <input {...props.input} id="ninetyDay-radio-filter" type="radio" name="dateFilterRadios" value="90" onClick={()=>{props.fetchPosOrdersByDetails('90');}} checked={props.input.value === '90'} />
            90 <Translate value="days" />
          </label>
        </div>
      </Button>
      <Button bsStyle={getBsStyle(props.input.value, '-1')}>
        <div className="radio">
          <label htmlFor="dateRange-radio-filter">
            <input {...props.input} id="dateRange-radio-filter" type="radio" name="dateFilterRadios" value="-1" checked={props.input.value === '-1'} />
            <Translate value="date_range" />
          </label>
        </div>
      </Button>
      {renderStartDatePicker(props.Days)}
      {renderEndDatePicker(props.Days)}
      <Button
        bsStyle="primary"
        className="search-btn"
        type="submit"
        onClick={() => { props.fetchPosOrdersByDetails(); }}
      >
        <em className="fa fa-search" />
      </Button>
    </ButtonToolbar>
  );
};

let renderStatusRadios = (props) => {
  return (
    <ButtonToolbar className="radio-filter-buttons">
      <Button bsStyle={getBsStyle(props.input.value, 'all')}>
        <div className="radio">
          <label htmlFor="all-radio-filter">
            <input {...props.input} id="all-radio-filter" type="radio" name="statusFilterRadios" value="all" checked={props.input.value === 'all'} />
            <Translate value="all" />
          </label>
        </div>
      </Button>
      <Button bsStyle={getBsStyle(props.input.value, 'Receipt')}>
        <div className="radio">
          <label htmlFor="receipt-radio-filter">
            <input {...props.input} id="receipt-radio-filter" type="radio" name="statusFilterRadios" value="Receipt" checked={props.input.value === 'Receipt'} />
            <Translate value="receipt" />
          </label>
        </div>
      </Button>
      <Button bsStyle={getBsStyle(props.input.value, 'Void')}>
        <div className="radio">
          <label htmlFor="void-radio-filter">
            <input {...props.input} id="void-radio-filter" type="radio" name="statusFilterRadios" value="Void" checked={props.input.value === 'Void'} />
            <Translate value="void" />
          </label>
        </div>
      </Button>
      <Button bsStyle={getBsStyle(props.input.value, 'Draft')}>
        <div className="radio">
          <label htmlFor="draft-radio-filter">
            <input {...props.input} id="draft-radio-filter" type="radio" name="statusFilterRadios" value="Draft" checked={props.input.value === 'Draft'} />
            <Translate value="draft" />
          </label>
        </div>
      </Button>
    </ButtonToolbar>
  );
};


class PosOrders extends Component {
  static contextTypes = {
    router: React.PropTypes.object,
  };

  constructor() {
    super();
    this.state = {
      tableHeight: window.innerHeight - UI_HEIGHT.fiveLineButton,
      clear: true,

      posOrders: {
        rows: [],
        selectedRows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,
      },
      voidedRows: 0,
      voidedfinalPrice: 0,
      finalPrice: 0,
      voidedTotal: 0,
      retailSubtotal: 0,
      wholesaleSubtotal: 0,
      retailMargin: 0,
      wholesalesMargin: 0,
      posOrderDetail: {
        rows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,
      },
      checkAuthorizeOpen: false,
      graphVisibility: false,
      action: null,
      Customer: null,
      Type: null,
    };

    this.handleResize = this.handleResize.bind(this);
    this.printForm = this.printForm.bind(this);
    this.loadsPost = this.loadsPost.bind(this);
    this.fetchPosOrdersByDetails = this.fetchPosOrdersByDetails.bind(this);
    this.checkAuthorize = this.checkAuthorize.bind(this);
    this.openCheckAuthorize = this.openCheckAuthorize.bind(this);
    this.closeCheckAuthorize = this.closeCheckAuthorize.bind(this);
    this.openGraph = this.openGraph.bind(this);
    this.closeGraph = this.closeGraph.bind(this);
  }

  componentDidMount() {
    document.title = companyCodeTitle;
    window.addEventListener('resize', this.handleResize);
    this.props.fetchActiveCustomers();
    const {
      Days = this.props.Days || '1',
      Status = this.props.Status || 'all',
    } = this.props;
    this.props.setValue('posOrders', 'Days', Days);
    this.props.setDefaultOfForm('Status', Status, 'posOrders');
    this.props.setDefaultOfForm('Customer', null, 'posOrders');
    this.props.setDefaultOfForm('Type', null, 'posOrders');
    this.refreshList({
      Days,
      Status: 'all'
    })
  }

  // Once products are ready, reset state.
  componentWillReceiveProps(nextProps) {
    if (nextProps.checkPasswordSuccess && nextProps.checkPasswordSuccess !== this.props.checkPasswordSuccess) {
      this.closeCheckAuthorize();
      if (this.state.action === 'void') {
        this.voidOrder();
      }
    }
    const route = 'posOrders'; // this.context.router.routes[1].path;
    
    if (nextProps.posOrdersAll && nextProps.posOrdersAll !== this.props.posOrdersAll) {
      if (isEcity) {
        let retailMargin = nextProps.posOrdersAll.retailMargin;
        let wholesalesMargin = nextProps.posOrdersAll.wholesalesMargin;
        this.setState({ retailMargin, wholesalesMargin });
      }
    }
    
    if (nextProps.posOrders && nextProps.posOrders !== this.props.posOrders) {
      if (this.props.posOrdersFilter
          && this.props.posOrdersFilter.currentRows
          && this.context.router.routes[1].path === this.props.posOrdersFilter.currentPage) {
        let posOrders = nextProps.posOrders;
        let rows = [...this.state.posOrders.rows];
        rows = rows.map((r) => {
          const index = _.findIndex(posOrders, { Order_id: r.Order_id });
          if (index > -1) {
            r.OrderDate = posOrders[index].OrderDate
            r.DispatchDate = posOrders[index].DispatchDate
            r.SaleStatus = posOrders[index].SaleStatus
          } else {
            r = null;
          }
          return r;
        })
        rows = rows.filter((r) => {
          return r !== null
        })
        const newPosOrders = { ...this.state.posOrders, rows };
        if (this.props.posOrderDetail) {
          const posOrderDetail = { ...this.state.posOrderDetail, rows: this.props.posOrderDetail.POS_Order_Lines };
          this.setState({ posOrderDetail });
        }
        this.setState({ posOrders: newPosOrders });
        // this.props.setSalesOrdersFilter(null);
      } else {
        let finalPrice = 0;
        let voidedFinalPrice = 0;
        let retailSubtotal = 0;
        let wholesaleSubtotal = 0;
        let profit = 0;
        let voidProfit = 0;
        nextProps.posOrders.map(r => {
          if (r.SaleStatus === 'Void') {
            voidedFinalPrice += r.FinalPrice
            voidProfit += r.Profit
          }
          profit += r.Profit;
          finalPrice += r.FinalPrice;
          retailSubtotal += r.RetailSubtotal;
          wholesaleSubtotal += r.WholesaleSubtotal;
        })
        const posOrders = { ...this.state.posOrders, rows: nextProps.posOrders, filters: {} };
        const posOrderDetail = { ...this.state.posOrderDetail, rows: [] };
        this.setState({
          posOrders,
          posOrderDetail,
          finalPrice,
          voidedFinalPrice,
          retailSubtotal,
          wholesaleSubtotal,
          profit,
          voidProfit,
        });
        // this.props.setSalesOrdersFilter(null);
      }
    }
    if (nextProps.posOrderDetail && nextProps.posOrderDetail !== this.props.posOrderDetail) {
      console.log('is it here?>', nextProps.posOrderDetail)
      const posOrderDetail = { ...this.state.posOrderDetail, rows: nextProps.posOrderDetail.POS_Order_Lines };
      this.setState({ posOrderDetail });
    }

    if (nextProps.Status && nextProps.Status !== this.props.Status) {
      console.log('status will update', nextProps.Status);
      const posOrdersFilter = this.props.posOrdersFilter;
      if (!posOrdersFilter) {
        let seller = this.props.Seller
        if (this.props.Seller) {
          seller = this.props.Seller.value
        }
        const fromDate = this.props.FromDate ? this.formatDate(this.props.FromDate) : '1900-01-01';
        const toDate = this.props.ToDate ? this.formatDate(this.props.ToDate) : '3000-01-01';
        let days = this.props.Days;

        if (days == null) {
          days = 1;
        }
        const productNum = this.props.ProductNum;
        
        let customer = this.props.Customer;
        if (this.props.Customer) { customer = this.props.Customer.value; }
        
        let type = this.props.Type;
        if (this.props.Type) { type = this.props.Type.value; }
        this.props.fetchPosOrdersByFilter(fromDate, toDate, days, nextProps.Status, customer, type, this.props.selectedCompany);
      }
    }
    
    if (nextProps.Customer && nextProps.Customer !== this.props.Customer) {
      let posOrdersFilter = this.props.posOrdersFilter;
      if (!posOrdersFilter) {
        let seller = this.props.Seller;
        if (this.props.Seller) {
          seller = this.props.Seller.value;
        }
        const fromDate = this.props.FromDate ? this.formatDate(this.props.FromDate) : '1900-01-01';
        const toDate = this.props.ToDate ? this.formatDate(this.props.ToDate) : '3000-01-01';
        const productNum = this.props.ProductNum;
        
        let customer = nextProps.Customer;
        if (nextProps.Customer) {
          customer = nextProps.Customer.value;
        }
        
        let type = this.props.Type;
        if (this.props.Type) { type = this.props.Type.value; }
        this.props.fetchPosOrdersByFilter(fromDate, toDate, this.props.Days, this.props.Status, customer, type, this.props.selectedCompany);
      }
    }
    
    if (nextProps.Type && nextProps.Type !== this.props.Type) {
      console.log('nextProps.Type going to update', nextProps.Type)
      let posOrdersFilter = this.props.posOrdersFilter;
      if (!posOrdersFilter) {
        let seller = this.props.Seller;
        if (this.props.Seller) {
          seller = this.props.Seller.value;
        }
        const fromDate = this.props.FromDate ? this.formatDate(this.props.FromDate) : '1900-01-01';
        const toDate = this.props.ToDate ? this.formatDate(this.props.ToDate) : '3000-01-01';
        const productNum = this.props.ProductNum;
        
        let customer = this.props.Customer;
        if (this.props.Customer) { customer = this.props.Customer.value; }
        
        let type = nextProps.Type;
        if (nextProps.Type) { type = nextProps.Type.value; }
        this.props.fetchPosOrdersByFilter(fromDate, toDate, this.props.Days, this.props.Status, customer, type, this.props.selectedCompany);
      }
    }
    
    if (nextProps.Seller && nextProps.Seller !== this.props.Seller) {
      let posOrdersFilter = this.props.posOrdersFilter;
      if (!posOrdersFilter) {
        let seller = nextProps.Seller;
        if (nextProps.Seller) {
          seller = nextProps.Seller.value;
        }
        const fromDate = this.props.FromDate ? this.formatDate(this.props.FromDate) : '1900-01-01';
        const toDate = this.props.ToDate ? this.formatDate(this.props.ToDate) : '3000-01-01';
        const productNum = this.props.ProductNum;
        let customer = this.props.Customer;
        if (this.props.Customer) { customer = this.props.Customer.value; }
        let type = this.props.Type;
        if (this.props.Type) { type = this.props.Type.value; }
        this.props.fetchPosOrdersByFilter(fromDate, toDate, this.props.Days, this.props.Status, customer, type, this.props.selectedCompany);
      }
    }

    if (nextProps.selectedCompany && nextProps.selectedCompany !== this.props.selectedCompany) {
        const fromDate = this.props.FromDate ? this.formatDate(this.props.FromDate) : '1900-01-01';
        const toDate = this.props.ToDate ? this.formatDate(this.props.ToDate) : '3000-01-01';
        const productNum = this.props.ProductNum;
        let customer = this.props.Customer;
        if (this.props.Customer) { customer = this.props.Customer.value; }
        let type = this.props.Type;
        if (this.props.Type) { type = this.props.Type.value; }
        this.props.fetchPosOrdersByFilter(fromDate, toDate, this.props.Days, this.props.Status, customer, type, nextProps.selectedCompany);
    }

    if (this.props.Seller && nextProps.Seller === null) {
      const seller = nextProps.Seller;
      const fromDate = this.props.FromDate ? this.formatDate(this.props.FromDate) : '1900-01-01';
      const toDate = this.props.ToDate ? this.formatDate(this.props.ToDate) : '3000-01-01';
      const productNum = this.props.ProductNum;
      let customer = this.props.Customer;
      if (this.props.Customer) { customer = this.props.Customer.value; }
      let type = this.props.Type;
      if (this.props.Type) { type = this.props.Type.value; }
      this.props.fetchPosOrdersByFilter(fromDate, toDate, this.props.Days, this.props.Status, customer, type, this.props.selectedCompany);
    }

    if (nextProps.Days && nextProps.Days !== this.props.Days) {
      if (nextProps.Days !== -1) {
        console.log('next props. days !== -1',  nextProps.Days);
        this.props.setDefaultOfForm('FromDate', null, 'posOrders');
        this.props.setDefaultOfForm('ToDate', null, 'posOrders');
      }
    }
  }

  componentDidUpdate(nextProps, nextState) {
    if (nextState.posOrders && nextState.posOrders.rows && nextState.posOrders.rows !== this.state.posOrders.rows) {
      let voidedTotal = 0;
      const canceledOrders = this.state.posOrders.rows.filter(row => {
        const match = row.SaleStatus === 'Void';
        let voidTotal = 0;
        if (match) {
          voidTotal += row.FinalPrice;
        }
        return match;
      })
      this.setState({
        voidedRows: canceledOrders.length,
        voidedTotal: voidedTotal,
      })
    }
  }

  componentWillUnmount() {
    if (this.state.clear) {
      this.props.setSalesOrdersFilter(null);
    }
    window.removeEventListener('resize', this.handleResize);
  }

  refreshList = ({
    Days = this.props.Days,
    Status = this.props.Status,
  }) => {
    const fromDate = this.props.FromDate ? this.formatDate(this.props.FromDate) : '1900-01-01';
    const toDate = this.props.ToDate ? this.formatDate(this.props.ToDate) : '3000-01-01';
    // if (!Days) Days = this.props.Days;
    // if (!Stat)
    this.props.fetchPosOrdersByFilter(fromDate, toDate, Days, Status, this.props.Customer && this.props.Customer.value, this.props.Type, this.props.selectedCompany);
  }

  // Set product being selected to be currentProduct and navigate user to the edit page
  setCurrentPosOrder(e) {
    e.preventDefault();
    this.setState({ clear: false });
    const currentPosOrderId = this.state.posOrders.selectedRows[0].Order_id;
    const posOrders = this.state.posOrders.rows.filter((row) => {
      const match = row.PosOrder_id === currentPosOrderId;
      return match;
    });

    const FromDate = this.props.FromDate;
    const ToDate = this.props.ToDate;
    // this.props.resetCurrentPosOrder();
    // this.props.selectPosOrder(posOrders[0]);
    const currentRows = Data.Selectors.getRows(this.state.posOrders);
    const route = 'posOrders'; // this.context.router.routes[1].path;
    this.props.setSalesOrdersFilter({
      Days: this.props.Days,
      FromDate,
      ToDate,
      Status: this.props.Status,
      Seller: this.props.Seller,
      ProductNum: this.props.ProductNum,
      currentRows,
      currentPage: route,
    });
    // this.context.router.push('/posOrders/'+currentPosOrder.PosOrder_id);
    this.context.router.push(`/${this.context.router.routes[1].path}/${currentPosOrderId}`);
  }

  checkAuthorize(password) {
    this.props.checkPassword(password);
  }

  openCheckAuthorize(action) {
    this.props.clearCheckPassword();
    this.setState({ checkAuthorizeOpen: true, action });
  }

  closeCheckAuthorize() {
    this.setState({ checkAuthorizeOpen: false });
  }

  openGraph() {
    this.setState({ graphVisibility: true });
  }

  closeGraph() {
    this.setState({ graphVisibility: false });
  }

  clickNew(e) {
    e.preventDefault();
    this.props.resetCurrentPosOrder();
    // this.context.router.push('/posOrders/new')
    this.context.router.push(`/${this.context.router.routes[1].path}/new`);
  }

  voidOrder() {
    const { rows } = this.state.posOrders;
    this.state.posOrders.selectedRows.map((row) => {
      this.props.voidPosOrder(row.Order_id);
      rows.map((origRow) => {
        if (origRow.Order_id === row.Order_id) {
          origRow.SaleStatus = 'Void';
        }
      });
      const posOrders = { ...this.state.posOrders, rows };
      this.setState({ posOrders });
    });
  }

  renderTotalProfit = () => {
    if (isCPG || isSUN) {
      return <label className="grand-total">
      <span className="grand-total-label">
        <Translate value="total_profit" />:&nbsp;
      </span>
      <span className="font-color-grey" id="total-equation">
        {`$${numberWithCommas((this.state.profit || 0).toFixed(2))} - $${numberWithCommas((this.state.voidProfit || 0).toFixed(2))} = $${numberWithCommas((this.state.profit - this.state.voidProfit).toFixed(2))}`}
      </span>
    </label>
    }
  }

  shouldVoidButtonDisable() {
    const { selectedRows } = this.state.posOrders;

    // Always disable void if selected more than 1 row
    if (selectedRows.length !== 1) {
      return true;
    }

    const status = selectedRows[0] ? selectedRows[0].SaleStatus : 'disable';
    const disabled = (status === 'Void' || status === 'disable');
    return disabled;
  }

  printForm(e) {
    e.preventDefault();
  }

  loadsPost() {
    this.props.loadsPost(this.state.posOrders.selectedRows[0].PosOrder_id);
  }

  // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
  renderTable() {
    let route = 'posOrders';// this.context.router.routes[1].path
    if (this.props.isLoading && !this.props.error) {
      return <Spinner />
    } else if (this.props.error) {
      return <ContentWrapper>
        <div className="alert alert-danger">{JSON.stringify(this.props.error)}</div>
      </ContentWrapper>
    }
    // Parameters of the react-data-grid
    const tableHeight = (window.innerHeight < 930) ? 270 : 270

    const getRows = () => Data.Selectors.getRows(this.state.posOrders);

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    const onClearFilters = () => {
      // all filters removed
      const posOrders = { ...this.state.posOrders, filters: {} };
      this.setState({ posOrders });
    };

    // Handle the sortable function
    const handleGridSort = (sortColumn, sortDirection) => {
      const state = Object.assign({}, this.state.posOrders, { sortColumn, sortDirection });
      this.setState({ posOrders: state });
    };

    const handleFilterChange = (filter) => {
      this.state.posOrders.rows = this.props.posOrders;
      this.state.posOrders.selectedRows = [];
      const newFilters = Object.assign({}, this.state.posOrders.filters);
      if (filter.filterTerm) {
        newFilters[filter.column.key] = filter;
      } else {
        delete newFilters[filter.column.key];
      }
      const posOrders = { ...this.state.posOrders, filters: newFilters };
      this.setState({ posOrders });
    };

    // Handle the row select function
    const onRowClick = (rowIdx, row) => {
      if (rowIdx !== -1) {
        const rows = getRows();

        /* Single row select on row click */
        rows.map((r) => {
          r.isSelected = false;
        });
        const selectedRows = [rows[rowIdx]];
        rows[rowIdx].isSelected = true;

        const posOrders = { ...this.state.posOrders, rows, selectedRows };
        this.setState({ posOrders });
        this.props.fetchPosOrderDetail(row.Order_id, route);
      }
    };

    const onRowSelect = (rows) => {
      const posOrders = { ...this.state.posOrders, selectedRows: rows };
      this.setState({ posOrders });
    };

    const onCellSelected = (coordinates) => {
      const newRows = getRows();

      /* Single row select on cell selected */
      newRows.map((r) => {
        r.isSelected = false;
      });
      const selectedRows = [newRows[coordinates.rowIdx]];
      newRows[coordinates.rowIdx].isSelected = true;
      const posOrders = { ...this.state.posOrders, rows: newRows, selectedRows };
      this.setState({ posOrders });
    };

    const onRowsSelected = (rows) => {
      const newRows = getRows();
      const selectedRows = [...this.state.posOrders.selectedRows];

      rows.map((r) => {
        newRows[r.rowIdx].isSelected = true;
        selectedRows.push(r.row);
      });
      const posOrders = { ...this.state.posOrders, rows: newRows, selectedRows };
      this.setState({ posOrders });
    };

    const onRowsDeselected = (rows) => {
      const newRows = [...this.state.posOrders.rows];
      const selectedRows = [...this.state.posOrders.selectedRows];
      rows.map((r) => {
        newRows[r.rowIdx].isSelected = false;
        let rowIndex = selectedRows.indexOf(r.row);
        selectedRows.splice(rowIndex, 1);
      });
      const posOrders = { ...this.state.posOrders, rows: newRows, selectedRows };
      this.setState({ posOrders });
    };

    // Custom Formatter component
    const DateFormatter = React.createClass({
      render() {
        if (this.props.value) {
          const date = new Date(this.props.value);
          return <span>{date.toString().slice(4, 24)}</span>;
        }
        return <span className="label label-danger">-</span>;
      }
    });

    // Column difinition
    const columns = [
      {
        key: 'Order_Num',
        name: <Translate value="order_no" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 135,
      },
      {
        key: 'Sales_User_Name',
        name: <Translate value="sales" />,
        resizable: true,
        sortable: true,
        width: 90,
        filterable: true,
      },
      {
        key: 'SaleStatus',
        name: <Translate value="status" />,
        resizable: true,
        sortable: true,
        width: 65,
        filterable: true,
      },
      {
        key: 'Date',
        name: <Translate value="date" />,
        resizable: true,
        sortable: true,
        width: 130,
        filterable: true,
        formatter: DateFormatter,
      },
      {
        key: 'FinalPrice',
        name: <Translate value="final_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 75,
        filterable: true,
      },
      {
        key: 'SalesMargin',
        name: <Translate value="sales_margin_percentsign" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: PercentFormatter,
      },
      {
        key: 'CreditCardAmount',
        name: <Translate value="credit_card_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 75,
        filterable: true,
      },
      {
        key: 'EBTCardAmount',
        name: <Translate value="ebt_card_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 75,
        filterable: true,
      },
      {
        key: 'CheckAmount',
        name: <Translate value="check_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 75,
        filterable: true,
      },
      {
        key: 'CashAmount',
        name: <Translate value="cash_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 75,
        filterable: true,
      },
      ...isEcity ? [{
        key: 'SavingRate',
        name: <Translate value="discount_rate_%" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: PercentFormatter,
      }] : [{
        key: 'StoreCreditAmount',
        name: <Translate value="store_credit_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      }],
      ...isEcity ? [{
        key: 'Savings',
        name: <Translate value="discount_$" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }] : [{
        key: 'MobileAmount',
        name: <Translate value="mobile_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      }],
      {
        key: 'Customer_Name',
        name: <Translate value="Customer_Name" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        // formatter: NameFormatter
      },
      ...(isEcity ? [{
          key: 'RetailSubtotal',
          name: <Translate value="Retail_Subtotal" />,
          resizable: true,
          sortable: true,
          width: 100,
        },
        {
          key: 'WholesaleSubtotal',
          name: <Translate value="Wholesale_Subtotal" />,
          resizable: true,
          sortable: true,
          width: 90,
        }] : []
      ),
      {
        key: 'Customer_Num',
        name: <Translate value="Customer_Num" />,
        resizable: true,
        sortable: true,
        width: 90,
        filterable: true,
        // formatter: NameFormatter
      },
      {
        key: 'SalesTax',
        name: <Translate value="SalesTax" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      ...(isMMD ? [{
        key: 'Savings',
        name: <Translate value="savings" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      }] : []),
      {
        key: 'OthersPaymentType',
        name: <Translate value="payment_type" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      ...isEcity ? [{
        key: 'StoreCreditAmount',
        name: <Translate value="store_credit_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      }]: [],
      ...isEcity ? [{
        key: 'MobileAmount',
        name: <Translate value="mobile_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      }]: [],
    ];

    if (isARC) {
      const mobileIdx = _.findIndex(columns, { key: 'MobileAmount' });
      const temp1 = {
        key: 'GiftcardAmount',
        name: <Translate value="gift_card" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      }
      columns.splice(mobileIdx, 0, temp1);
    }
    if (isCPG || isSUN) {
      const CreditCardAmountIdx = _.findIndex(columns, { key: 'CreditCardAmount' });
      const temp1 = {
        key: 'Profit',
        name: <Translate value="profit_dollar" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
        getRowMetaData: row => row,
        formatter: ({ dependentValues }) => {
          return <div>{dependentValues.Profit && dependentValues.Profit.toFixed(2)}</div>
        }
      }
      columns.splice(CreditCardAmountIdx, 0, temp1);
    }

    return (
      // React Table Sales Order History Table
      <div>
        <Row>
          <Col xs={12} style={{ marginTop: '-30px' }}>
            <div id="PosOrders-dataGrid1">
              <ReactDataGrid
                rowKey="PosOrder_id"
                onGridSort={handleGridSort}
                toolbar={<Toolbar enableFilter={true} />}
                onAddFilter={handleFilterChange}
                columns={columns}
                rowHeight={25}
                headerRowHeight={45}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                onClearFilters={onClearFilters}
                minHeight={tableHeight}
                enableRowSelect="multi"
                rowSelection={{
                  showCheckbox: true,
                  onRowsSelected,
                  onRowsDeselected,
                  selectBy: {
                    isSelectedKey: 'isSelected',
                  },
                }}
                onRowClick={onRowClick}
                onCellSelected={onCellSelected}
                onRowSelect={onRowSelect}
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <Col xs={2}>
              <label className="row-count">
                <Translate value="total_orders" />:&nbsp;
                <span className="font-color-orange" id="row-count-equation">
                  { getSize()} - {this.state.voidedRows} = {getSize() - this.state.voidedRows}
                </span>
              </label>
            </Col>
            <Col xs={6}>
              <label className="grand-total">
                <span className="grand-total-label">
                  <Translate value="grand_total" />:&nbsp;
                </span>
                <span className="font-color-grey" id="total-equation">
                  {`$${numberWithCommas((this.state.finalPrice || 0).toFixed(2))} - $${numberWithCommas((this.state.voidedfinalPrice || 0).toFixed(2))} = $${numberWithCommas((this.state.finalPrice - this.state.voidedfinalPrice).toFixed(2))}`}
                </span>
              </label>
              {this.renderTotalProfit()}
            </Col>
            <Col xs={4}>
              <div className="mso-footnotes">
                <span><Translate value="msg_total_orders_equation" /></span>
                <span><Translate value="msg_grand_total_equation" /></span>
              </div>
            </Col>
          </Col>
        </Row>
        { isEcity &&
          <Row>
            <Col xs={12}>
              <Col xs={3}>
                <label className="row-count">
                  <Translate value="retail_subtotal" />:&nbsp;
                  <span className="font-color-grey" id="row-count-equation">
                    {`$${numberWithCommas((this.state.retailSubtotal || 0).toFixed(2))}`}
                  </span>
                </label>
              </Col>
              <Col xs={3}>
                <label className="row-count">
                  <Translate value="wholesale_subtotal" />:&nbsp;
                  <span className="font-color-grey" id="row-count-equation">
                    {`$${numberWithCommas((this.state.wholesaleSubtotal || 0).toFixed(2))}`}
                  </span>
                </label>
              </Col>
              <Col xs={3}>
                <label className="row-count">
                  <Translate value="retail_margin" />:&nbsp;
                  <span className="font-color-grey" id="row-count-equation">
                    {`${numberWithCommas((this.state.retailMargin * 100 || 0).toFixed(2))} %`} 
                  </span>
                </label>
              </Col>
              <Col xs={3}>
                <label className="row-count">
                  <Translate value="retail_margin" />:&nbsp;
                  <span className="font-color-grey" id="row-count-equation">
                    {`${numberWithCommas((this.state.wholesalesMargin * 100 || 0).toFixed(2))} %`}
                  </span>
                </label>
              </Col>
            </Col>
          </Row>
        }
      </div>
    );
  }

  renderDatePickers() {
    if (this.props.Days === -1) {
      return (
        <div className="form-group date-picker-positioner">
          <label className="col-xs-2 from-label col-xs-offset-5"><Translate value="from" /></label>
          <div className="col-xs-2 control-date-picker">
            <Field name="FromDate" component={DatePicker} />
          </div>
          <label className="col-xs-1 to-label"><Translate value="to" /></label>
          <div className="col-xs-2 control-date-picker">
            <Field name="ToDate" component={DatePicker} />
          </div>
        </div>
      );
    }
  }

  // customers
  renderCustomers() {
    // If group is loading, show a spinner.
    if (this.props.customersIsLoading) { return <Spinner />; }
    const Customers = this.getCustomers();
    // name Customer__Customer_id
    return (
      <div className="control-dropdown">
        <Field name="Customer" component={Selection} options={Customers} />
      </div>
    );
  }
  getCustomers() {
    const Customers = [];
    this.props.customers.map((customer) => {
      Customers.push({ value: customer.Customer_id, label: customer.Name });
    });
    return Customers;
  }
  
  renderTypes() {
    const Types = [
      { value: ' ', label: 'All' },
      { value: '&RetailSubtotal__gt=0', label: 'Retail' },
      { value: '&WholesaleSubtotal__gt=0', label: 'Wholesale' },
    ]
    
    // name Customer__Customer_id
    return (
      <div className="control-dropdown">
        <Field name="Type" component={Selection} options={Types} />
      </div>
    );
  }

  handleResize() {
    this.setState({ tableHeight: window.innerHeight - UI_HEIGHT.fiveLineButton });
  }

  fetchPosOrdersByDetails(value) {
    let dateRange = 7;
    let FromDate = '1900-01-01';
    let ToDate = '3000-01-01';
    let seller = this.props.Seller;
    const productNum = this.props.ProductNum;
    const route = 'posOrders'; // this.context.router.routes[1].path;
    if (this.props.FromDate !== null) { FromDate = this.formatDate(this.props.FromDate); }
    if (this.props.ToDate !== null) { ToDate = this.formatDate(this.props.ToDate); }
    if (this.props.Days !== null) { dateRange = this.props.Days; }
    if (value) {
      dateRange = value;
    }
    if (this.props.Seller) { seller = this.props.Seller.value; }
    
    let customer = this.props.Customer;
    if (this.props.Customer) { customer = this.props.Customer.value; }
    
    let type = this.props.Type;
    if (this.props.Type) { type = this.props.Type.value; }
    this.props.fetchPosOrdersByFilter(FromDate, ToDate, dateRange, this.props.Status, customer, type, this.props.selectedCompany);
  }

  formatDate(date) {
    let formattedDate = date.getFullYear() + '-';
    formattedDate += date.getMonth()+1 + '-';
    if (date.getDate() < 10) { formattedDate += '0' + date.getDate(); }
    else {formattedDate += date.getDate();}
    return formattedDate;
  }

  // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
  renderProductsTable() {
    if (this.props.posOrderIsLoading && !this.props.posOrderError) {
      return <Spinner />
    } else if (this.props.posOrderError) {
      return (
        <ContentWrapper>
          <div className="alert alert-danger">{JSON.stringify(this.props.posOrderError)}
          </div>
        </ContentWrapper>
      );
    }

    // Parameters of the react-data-grid
    let tableHeight = (window.innerHeight < 930) ? 185 : 185;

    const getRows = () => Data.Selectors.getRows(this.state.posOrderDetail);

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    // Handle the sortable function
    const handleGridSort = (sortColumn, sortDirection) => {
      const state = Object.assign({}, this.state.posOrderDetail, { sortColumn: sortColumn, sortDirection: sortDirection });
      this.setState({ posOrderDetail: state });
    };

    const onClearFilters = () => {
      // all filters removed
      const posOrderDetail = { ...this.state.posOrderDetail, filters: {} };
      this.setState({ posOrderDetail });
    };

    const handleFilterChange = (filter) => {
      const newFilters = Object.assign({}, this.state.posOrderDetail.filters);
      if (filter.filterTerm) {
        newFilters[filter.column.key] = filter;
      } else {
        delete newFilters[filter.column.key];
      }
      const posOrderDetail = { ...this.state.posOrderDetail, filters: newFilters };
      this.setState({ posOrderDetail });
    };

    // Handle the row select function
    const onRowSelect = (rows) => {
      const posOrderDetail = { ...this.state.posOrderDetail, selectedRows: rows };
      this.setState({ posOrderDetail });
    };

    // Custom Formatter component
    const IsVariableFormatter = React.createClass({
      render() {
        if (this.props.dependentValues.ProductType !== 'Non-Fixed') {
          return <span>{this.props.value} </span>
        }
        return <span>{this.props.value} <label className="label label-success"><Translate value="non_fixed" /></label></span>;
      },
    });

    // Column definition
    const columns = [
      ...isOLG ? [] : [{
        key: 'ProductNum',
        name: <Translate value="product_num" />,
        resizable: true,
        sortable: true,
        width: 100,
      }],
      {
        key: 'RefNum',
        name: <Translate value={isOLG ? "item_no" : "ref_num"} />,
        resizable: true,
        sortable: true,
        width: 70,
      },
      {
        key: 'Name',
        name: <Translate value="product_name" />,
        resizable: true,
        sortable: true,
        width: 200,
      },
      {
        key: 'Description',
        name: <Translate value="description" />,
        resizable: true,
        sortable: true,
        width: 150,
      },
      {
        key: 'Quantity',
        name: <Translate value="qty" />,
        resizable: true,
        width: 40,
        sortable: true,
        formatter: IsVariableFormatter,
        getRowMetaData: row => row,
      },
      {
        key: 'PackageType',
        name: <Translate value="pkg_type" />,
        resizable: true,
        width: 80,
        sortable: true,
      },
      {
        key: 'TotalNetWeight',
        name: <Translate value="total_wt" />,
        resizable: true,
        width: 80,
        sortable: true,
      },
      {
        key: 'UnitPrice',
        name: <Translate value="unit_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
      },
      {
        key: 'TotalPrice',
        name: <Translate value="total_dollarsign" />,
        resizable: true,
        width: 80,
        sortable: true,
      },
      {
        key: "UnitArrivalPrice",
        name: <Translate value="arrival_price" />,
        resizable: true,
        width: 80,
        sortable: true,
      },
      ...isEcity ? [{
        key: 'ProductMargin',
        name: <Translate value="sales_margin_percentsign" />,
        resizable: true,
        sortable: true,
        width: 100,
        formatter: PercentFormatter,
      }]: [],
    ];

    return (
      // Sales Invoice Details
      <Row>
        <Col xs={12}>
          <div id="PosOrders-dataGrid2">
            <ReactDataGrid
              rowKey="PosOrder_id"
              onGridSort={handleGridSort}
              onAddFilter={handleFilterChange}
              onClearFilters={onClearFilters}
              columns={columns}
              rowGetter={rowGetter}
              rowsCount={getSize()}
              rowHeight={25}
              headerRowHeight={45}
              minHeight={tableHeight}
              onRowUpdated={this.handleRowUpdated}
              onRowSelect={onRowSelect}
            />
          </div>
        </Col>
      </Row>
    );
  }

  renderExcel() {
    if (this.state.posOrders.selectedRows.length) { return; }
    const { FromDate, ToDate, Days, Status } = this.props;
    const { fromDate, toDate } = toFromDates(Days, FromDate, ToDate);
    const status = (Status === 'all') ? '' : '&SaleStatus=' + Status;
    let excelUrl = ROOT_URL + 'v1/pos/orders/excel/?Date__gte='+ fromDate +'&Date__lte='+ toDate + status + '&Bearer=' + localStorage.getItem('token');
    let company = this.props.selectedCompany.value ? this.props.selectedCompany.value : this.props.selectedCompany;
    if (isGFD) {
      excelUrl = ROOT_URL + 'v1/pos/orders/excel/?Date__gte='+ fromDate +'&Date__lte='+ toDate + status + '&Bearer=' + localStorage.getItem('token') + '&Company_id=' + company;
    }
    return (
      <div>
        <Button
          bsStyle="success"
          type="button"
          href={excelUrl}
          style={{ marginLeft: '5px' }}
        >
          <em className="fa fa-download" /><Translate value="excel" />
        </Button>
      </div>
    );
  }

  renderPrintExcel() {
    let posOrder_id = this.state.posOrders.selectedRows.length == 1 && this.state.posOrders.selectedRows[0].Order_id;
    if (!posOrder_id) { return; }
    let printUrl = ROOT_URL + 'v1/pos/orders/print/' + posOrder_id + '?Bearer=' + localStorage.getItem('token');
    let excelUrl = ROOT_URL + 'v1/pos/orders/excel/' + posOrder_id + '?Bearer=' + localStorage.getItem('token');
    let company = this.props.selectedCompany.value ? this.props.selectedCompany.value : this.props.selectedCompany;
    if (isGFD) {
      printUrl = ROOT_URL + 'v1/pos/orders/print/' + posOrder_id + '?Bearer=' + localStorage.getItem('token') + '&Company_id=' + company;
      excelUrl = ROOT_URL + 'v1/pos/orders/excel/' + posOrder_id + '?Bearer=' + localStorage.getItem('token') + '&Company_id=' + company;
    }

    return (
      <div>
        {/*
          <a href= {shipping_url}>
            <Button
              bsStyle='primary'
              type='button'
              href={picking_url} >
              <em className='fa fa-print' /><Translate value="picking_list" />
            </Button>
            <Button
              bsStyle='primary'
              type='button'
              href={shipping_url}>
              <em className='fa fa-print' /><Translate value="shipping_list" />
            </Button>
            <Button
              bsStyle='primary'
              type='button'
              href={packing_url}>
              <em className='fa fa-print' /><Translate value="packing_list" />
            </Button>
          </a>
        */}
        {/* <a href= {url}> */}
        <Button
          bsStyle="primary"
          type="button"
          href={printUrl}
          style={{ marginLeft: '5px' }}
        >
          <em className="fa fa-print" /><Translate value="print" />
        </Button>
        <Button
          bsStyle="success"
          type="button"
          href={excelUrl}
          style={{ marginLeft: '5px' }}
        >
          <em className="fa fa-download" /><Translate value="excel" />
        </Button>
        {/* </a> */}
      </div>
    )
  }

  renderMemberShipCard = () => {
    if (!isARC) return;
    const url = `${ROOT_URL}v1/pos/print_member_single?Bearer=${localStorage.getItem('token')}`
    return (<div>
        <Button
          bsStyle="primary"
          type="button"
          href={url}
          style={{ marginLeft: '5px' }}
        >
          <em className="fa fa-print" /><Translate value="membership_card" />
        </Button>
      </div>
    )
  }

  renderMultiSelectPrintExcel() {
    let posOrderIds = [];
    const { posOrders } = this.state;
    if (posOrders.selectedRows) {
      posOrders.selectedRows.map((row) => {
        posOrderIds.push(row.Order_id);
      });
    };
    if (!posOrderIds.length) return;

    let printUrl = ROOT_URL + 'v1/pos/orders/print/' + posOrderIds.join(',') + '?Bearer=' + localStorage.getItem('token');
    let excelUrl = ROOT_URL + 'v1/pos/orders/excel/' + posOrderIds.join(',') + '?Bearer=' + localStorage.getItem('token');
    let company = this.props.selectedCompany.value ? this.props.selectedCompany.value : this.props.selectedCompany;
    if (isGFD) {
       printUrl = ROOT_URL + 'v1/pos/orders/print/' + posOrderIds.join(',') + '?Bearer=' + localStorage.getItem('token') + '&Company_id=' + company;
       excelUrl = ROOT_URL + 'v1/pos/orders/excel/' + posOrderIds.join(',') + '?Bearer=' + localStorage.getItem('token') + '&Company_id=' + company;
     }
    return (
      <div>
        <Button
          bsStyle="primary"
          type="button"
          disabled={!posOrderIds.length}
          href={printUrl}
          style={{ marginLeft: '5px' }}
        >
          <em className="fa fa-print" /><Translate value="print" />
        </Button>
        <Button
          bsStyle="success"
          type="button"
          href={excelUrl}
          disabled={!posOrderIds.length}
          style={{ marginLeft: '5px' }}
        >
          <em className="fa fa-download" /><Translate value="excel" />
        </Button>
      </div>
    )
  }

  renderPrintReward() {
    const printUrl = ROOT_URL + 'v1/pos/print_rewards' + '?Bearer=' + localStorage.getItem('token');
    return (
      <Button
      bsStyle="primary"
      type="button"
      href={printUrl}
      >
        <em className="fa fa-print" /><Translate value="rewards" />
      </Button>
    );
  }

  renderExportButton() {
    const { Status, FromDate, ToDate, Days } = this.props;
    const status = (Status === 'all') ? '' : `&SaleStatus=${Status}`;
    const dateRange = Days || -1;
    const fromDate = FromDate ? this.formatDate(FromDate) : '1900-01-01';
    const toDate = ToDate ? this.formatDate(ToDate) : '3000-01-01';

    const route = 'posOrders'; // this.props.route.path;
    const orderType = 'pos_order';

    const exportUrl = ROOT_URL + 'v1/sale/' + orderType + '/search/' +
    dateRange + '/export/?OrderDate__gte=' + fromDate + '&OrderDate__lte=' +
    toDate + status + '&Bearer=' + localStorage.getItem('token');

    return (
      <Button
        bsStyle="success"
        className="export-to-excel"
        href={exportUrl}
      >
        <em className="fa fa-download" />
        <Translate value="export" />
      </Button>
    );
  }

  render() {
    const createDialogStyle = {
      width: '550px',
      height: '300px',
      marginLeft: '-15%',
    };
    const graphDialogStyle = {
      width: '1300px',
      height: '630px',
      marginLeft: '-35%',
      marginTop: "-310px",
    };
    let posOrder_id = this.state.posOrders && this.state.posOrders.selectedRows[0] && this.state.posOrders.selectedRows[0].Order_id;
    posOrder_id = posOrder_id || '';
    return (
      //---------------
      // Begin HTML
      //---------------
      <ContentWrapper>
        {/* Nav Trail */}
        <Breadcrumb>
          <Breadcrumb.Item>
            <Translate value="pos_management" />
          </Breadcrumb.Item>
          <Breadcrumb.Item active="true">
            <Translate value="pos_orders" />
          </Breadcrumb.Item>
        </Breadcrumb> {/* End Nav Trail */}

        <Grid id="sales-orders-list">
          <h1><Translate value="pos_order_full_table" /></h1>

          {/* Date Range Picker */}
          <Row>
            <Col xs={12}>
              <Panel id="date-range-picker" className="form-horizontal">
                <Row>
                  <Col xs={1}>
                    <h3 className="filter-title"><Translate value="order_type" /><span className="colon">:</span></h3>
                  </Col>
                  <Col xs={11}>
                    <div id="statusFilterRadios" className="form-horizontal">
                      <Field name="Status" component={renderStatusRadios} />
                    </div>
                  </Col>
                  <Col xs={1}>
                    <h3 className="filter-title"><Translate value="date" /><span className="colon">:</span></h3>
                  </Col>
                  <Col xs={11}>
                    <Field name="Days" component={renderRadios} fetchPosOrdersByDetails={this.fetchPosOrdersByDetails} Days={this.props.Days} />
                  </Col>
                </Row>
              </Panel>
            </Col>
          </Row>
          {/* End Date Range Picker */}

          {/* Sales Order Full Table  */}
          <Row>
            <Col xs={12}>
              <Panel className="position-relative table-collapse-fix">
                {isEcity &&
                  <div style={{ display: 'flex'}}>
                    <label><Translate value="select_customer" /></label>
                    <div>
                      {this.renderCustomers()}
                    </div>
                    <label><Translate value="type" /></label>
                    <div>
                      {this.renderTypes()}
                    </div>
                  </div>
                }
                <ButtonToolbar className="table-buttons">
                  {/* <Button
                    bsStyle='success'
                    type='submit'
                    onClick={(event) => { this.clickNew(event) } }
                    disabled={this.context.router.routes[1].path == 'mobilePosOrders' || this.checkPermission('add_sales_order')}>
                    <em className='fa fa-plus' /><Translate value="create" />
                  </Button> */}
                  <Button
                    bsStyle="default"
                    type="button"
                    disabled={this.state.posOrders.selectedRows.length !== 1 || !checkPermission('view_pos')}
                    onClick={(event) => { this.setCurrentPosOrder(event); }}
                  >
                    <em className="fa fa-eye" /><Translate value="view" />
                  </Button>
                  <Button
                    bsStyle="danger"
                    type="button"
                    disabled={this.shouldVoidButtonDisable() || !checkPermission('add_void_order')}
                    onClick={() => { this.openCheckAuthorize('void'); }}
                  >
                    <em className="fa fa-trash" /><Translate value="void" />
                  </Button>
                  {
                    (isMMD || isGFD || isARC) &&
                  <Button
                    bsStyle="success"
                    type="button"
                    onClick={() => { this.openGraph(); }}
                  >
                    <em className="fa fa-eye" /><Translate value="graphical_data" />
                  </Button>
  }
                  {isEcity && this.renderPrintReward()}
                  {this.renderExcel()}
                  {/* {this.renderPrintExcel()} */}
                  {this.renderMultiSelectPrintExcel()}
                  {/* {this.renderMemberShipCard()} */}
                </ButtonToolbar>
                {/* 
                <div className='table-filters' style={{zIndex:1}}>
                  <div className='control-dropdown'>
                      <Field name='ProductNum' component={InputField} placeholder='Prod No.'/>
                  </div>
                  <ButtonToolbar>
                    <Button bsStyle='primary' onClick={() => { this.fetchSalesOrdersByDetails(); }}>
                      <em className='fa fa-search' />
                    </Button>
                    <Button bsStyle='primary' disabled={this.state.posOrders.selectedRows.length != 1} onClick={this.loadsPost}>
                      <Translate value="loads_post" />
                    </Button>
                    { this.renderExportButton() }
                  </ButtonToolbar>
                </div>
                */}
                {/* Sales Order Full Table */}
                {this.renderTable() }
              </Panel>
            </Col>
          </Row>
          {/* End Sales Order Full Table  */}

          {/* Sale Order Details */}
          <Row>
            <Col xs={12}>
              <h2><Translate value="pos_order_details" /></h2>
              <Panel className="details-table-collapse-fix">
                {this.renderProductsTable()}
              </Panel>
            </Col>
          </Row> {/* Sale Order Details */}
        </Grid>
        <SkyLightStateless
          dialogStyles={createDialogStyle}
          isVisible={this.state.checkAuthorizeOpen}
          onCloseClicked={this.closeCheckAuthorize}
        >
          <ConfirmActionModal
            case="confirmPassword"
            closeC={this.checkAuthorize}
            checkPasswordFailure={this.props.checkPasswordFailure}
          />
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={graphDialogStyle}
          isVisible={this.state.graphVisibility}
          onCloseClicked={() => {
            this.closeGraph();
          }}
          title={"POS Data"}
        >
          <POSGraphModal
            // salesOrderId={singleSalesOrderId}
            // salesOrderNum={singleSalesOrderNum}
            // printSalesOrderLabelDSQ={this.props.printSalesOrderLabelDSQ}
            // singleSalesOrderId={singleSalesOrderId}
            selectedCompany={this.props.selectedCompany}
            closeGraph={this.closeGraph}
          />
        </SkyLightStateless>
      </ContentWrapper>
      //---------------
      // End HTML
      //---------------
    );
  }
}

export default PosOrders;



// WEBPACK FOOTER //
// ./master/jsx/components/Sales/posOrders.jsx